module.exports = __webpack_public_path__ + "1c85baba3538cb4cb05ba7196705894d.MP3";